<template>
  <div>
    <p class="titleModal">
      {{ $t('forms.labels.treatment') }}
    </p>
    <VTextField
      v-model="data.treatment"
      :label="$t('forms.labels.treatment')"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      data-cy="cyArTreatment"
    />
    <VTextField
      v-model="data.makerName"
      :label="$t('forms.labels.makerName')"
      :rules="{ required: true, min: 1, max: 1000 }"
      outlined
      data-cy="cyArMakerNameResin"
    />
    <VTextField
      v-model="data.resinNumber"
      :label="$t('forms.labels.resinNumber')"
      :rules="{ required: true, min: 1, max: 20 }"
      outlined
      data-cy="cyArResinNumberResin"
    />
    <VSelect
      v-model="data.resinType"
      :label="$t('forms.labels.resinType')"
      :validateAtInitialization="isEdition"
      :items="resinType"
      :required="true"
      outlined
      itemValue="key"
      data-cy="cyArResinTypeResin"
    />
    <VTextField
      v-model="data.age"
      :rules="{ required: true, min: 1, max: 200 }"
      :label="$t('forms.labels.age')"
      outlined
      data-cy="cyArResinAge"
    />
    <VTextField
      v-model="data.analysisReason"
      outlined
      :label="$t('forms.labels.analysisReason')"
      :rules="{ required: true, min: 1, max: 1000 }"
      data-cy="cyArResinReasonRequest"
    />
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';

import resinTypes from '@/constants/resinTypes';

export default {
    components: {
        VTextField,
        VSelect,
    },
    props: {
        analysisRequest: {
            type: Object,
            required: true,
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                treatment: this.analysisRequest.treatment,
                makerName: this.analysisRequest.makerName,
                resinNumber: this.analysisRequest.resinNumber,
                resinType: this.analysisRequest.resinType,
                age: this.analysisRequest.age,
                analysisReason: this.analysisRequest.analysisReason,
            },
        };
    },
    computed: {
        resinType() {
            return resinTypes.map(type => ({
                name: this.$t(`resinTypes.${type}`),
                key: type,
            }));
        },
    },
    watch: {
        data: {
            handler() {
                this.$emit('updateData', this.data);
            },
            deep: true,
        },
    },
};
</script>
